import React, { useState, useEffect } from "react";
import "./ChinaCities.scss";
import Topbar from "../../components/TopbarChina/Topbar";
import Card from "../../components/Card/Card";

import CityModal from "../../components/CityModal/CityModal";
import Footer from "../../components/Footer/Footer";
import cities from "./ data";

const ChinaCities = () => {
  const [showModal, setShowModal] = useState(false);
  const [info, setInfo] = useState({});

  useEffect(() => {
    document.body.style.overflow = showModal ? "hidden" : "unset";
  }, [showModal]);

  function handleClick(params) {
    setInfo(cities.find((el) => el.name === params));
    setShowModal(true)
  }
  

  return (
    <div className="cities-box">
      <Topbar bgColor={true} />
      {showModal && <CityModal cityInfo={info} showModal={setShowModal} />}

      <div className="city-cards">
        {cities.map((city) => (
          <Card
          
            click={(e) => handleClick(e.currentTarget.id)}
            id={city.name}
            title={city.name}
            url={city.url}
            key={city.name}
          />
        ))}
      </div>
      <Footer />
    </div>
  );
};

export default ChinaCities;
